export const errorboundary = {
  title: 'Kritieke fout',
  body: 'Onderstaande foutmelding is naar het DevOps team gestuurd, zij zullen zsm werken aan een oplossing.',
  tryAgain: ' Herstart de applicatie',
}
